import { Alert, Button } from '@modulor/react';
import { useSkeletonTranslation } from 'hooks/useSkeletonTranslation';
import type { FC } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { closeErrorPopUp, errorPopUpCodeSelector, isErrorPopUpOpenedSelector } from 'store/slices/errorPopUp';
import { merchantRedirectUrlSelector, platformSelector, returnUrlsSelector } from 'store/slices/global';
import { onReloadButtonClickHandler } from 'utils';

export const ErrorPopUp: FC = () => {
  const { skeletonT } = useSkeletonTranslation();
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(isErrorPopUpOpenedSelector);
  const error = useAppSelector(errorPopUpCodeSelector);
  const platform = useAppSelector(platformSelector);
  const { merchantSuccessUrl, merchantFailUrl, merchantProcessingUrl, merchantUrl } =
    useAppSelector(returnUrlsSelector);
  const merchantRedirectUrlFromState = useAppSelector(merchantRedirectUrlSelector);
  const errorMessage = error.message ? skeletonT(error.message) : skeletonT('PH_ERROR');
  const title = skeletonT('PH_ERROR');

  const onReload = () =>
    onReloadButtonClickHandler({
      platform,
      merchantRedirectUrlFromState,
      merchantSuccessUrl,
      merchantFailUrl,
      merchantProcessingUrl,
      merchantUrl,
    });
  const closePopUp = () => dispatch(closeErrorPopUp());

  return (
    <Alert open={isOpen} title={title} content={errorMessage} vertical>
      <Button variant="secondary" onClick={closePopUp}>
        {skeletonT('PH.CLOSE.BUTTON')}
      </Button>
      <Button variant="primary" onClick={onReload}>
        {skeletonT('PH.BUTTON.REFRESH')}
      </Button>
    </Alert>
  );
};
